import React from 'react';
import { twMerge } from 'tailwind-merge';

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  'aria-label': string;
  variant?: 'ghost' | 'subtle' | 'danger';
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

const variantClasses = {
  ghost: 'bg-transparent text-text-secondary hover:bg-surface hover:text-text-primary',
  subtle: 'bg-surface text-text-secondary hover:bg-bg-tertiary hover:text-text-primary',
  danger: 'bg-transparent text-text-secondary hover:bg-danger/10 hover:text-danger',
};

const sizeClasses = {
  xs: 'w-5 h-5 text-xs',
  sm: 'w-7 h-7 text-sm',
  md: 'w-9 h-9 text-base',
  lg: 'w-11 h-11 text-lg',
};

export function IconButton({
  icon,
  variant = 'ghost',
  size = 'md',
  className,
  ...props
}: IconButtonProps) {
  return (
    <button
      className={twMerge(
        'inline-flex items-center justify-center rounded-lg border-none cursor-pointer transition-colors',
        'focus-visible:outline-2 focus-visible:outline-accent focus-visible:outline-offset-2',
        variantClasses[variant],
        sizeClasses[size],
        className
      )}
      {...props}
    >
      {icon}
    </button>
  );
}
